import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-8">
              <Logo variant="white" size="md" />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed font-light max-w-md">
              Premium hospitality management for discerning property owners. 
              Elevating guest experiences across the USA, UAE, and Africa.
            </p>
            <div className="mb-6 p-4 bg-gray-800 rounded-lg">
              <p className="text-gray-400 text-sm font-light mb-2">Official Hospitality Partner</p>
              <div className="flex items-center space-x-3 mb-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hostease-global/artifacts/n2vzlpaz_OIA.png" 
                  alt="OIA Green Ventures" 
                  className="h-8 w-auto object-contain opacity-80"
                />
                <span className="text-gray-300 font-light text-sm">OIA Green Ventures</span>
              </div>
              <p className="text-gray-500 font-light text-xs">& Portfolio Companies since 2023</p>
            </div>
            <div className="flex space-x-6">
              <Instagram className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <Linkedin className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-medium text-lg mb-8 text-white">Services</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/hosts" className="text-gray-300 hover:text-white transition-colors font-light">
                  Property Management
                </Link>
              </li>
              <li>
                <Link to="/guests" className="text-gray-300 hover:text-white transition-colors font-light">
                  Guest Services
                </Link>
              </li>
              <li>
                <Link to="/service-providers" className="text-gray-300 hover:text-white transition-colors font-light">
                  Partner Network
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-300 hover:text-white transition-colors font-light">
                  Reservations
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-medium text-lg mb-8 text-white">Connect</h3>
            <ul className="space-y-6">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-gray-300 font-light">General</p>
                  <p className="text-sm text-gray-400 font-light">info@vantagepointshospitality.net</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-gray-300 font-light">Dubai Office</p>
                  <p className="text-sm text-gray-400 font-light">+971559302690</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-gray-300 font-light">Global Presence</p>
                  <p className="text-sm text-gray-400 font-light">USA • UAE • Africa</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-light mb-4 md:mb-0">
              © 2023 Vantage Points Hospitality. All rights reserved.
            </p>
            <div className="flex space-x-8 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors font-light">
                Privacy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors font-light">
                Terms
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors font-light">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;